import { useEffect,useState ,useMemo} from "react";

//este es el hook para convertir los precios

export function useConvertor(servicios,monedaDestino){
    const [preciosConvertidos,setPreciosConvertidos] = useState({})
    const from = "ARS";
    const servicioBase = useMemo(()=>{
    return servicios.map(({id,precio}) =>({id,precio}))
    },[servicios])
    const servicioBaseString = useMemo(()=> JSON.stringify(servicioBase),[servicioBase])
    useEffect(() => {
        if (!servicioBase || servicioBase.length === 0 || monedaDestino ==="ARS" ) return; 

        fetch(`https://v6.exchangerate-api.com/v6/1b4fc65dc92c6df6ab5a68ce/latest/${from}`)
        .then((res) => res.json())
        .then((data) => {
            const rate = data.conversion_rates[monedaDestino]
            if(!rate)return; 
            const nuevosPrecios = {};
            servicioBase.forEach(({id,precio})=>{
                const precioStr = precio?.toString().replace(/\./g, "").replace(/[^0-9,.-]/g, "")
                const nuevoPre = Number(precioStr) * 2
                nuevosPrecios[id] = (nuevoPre * rate).toFixed(2);
            })
            setPreciosConvertidos(nuevosPrecios)
            
        }).catch((err) => {console.error("error en la conversion", err)
            setPreciosConvertidos({})
        })

}, [servicioBaseString,monedaDestino])
    return{preciosConvertidos};
}